import * as ReactService from "@intech/react-service";
import { PlanoVinculadoEntidade } from "../entidades/PlanoVinculadoEntidade";
import { PlanoEntidade } from "../entidades/PlanoEntidade";

class Plano extends ReactService.BaseService {
  constructor() {
    super("Plano");
  }

  Buscar = () =>
    this.CreateRequest<PlanoVinculadoEntidade[]>(ReactService.RequestType.GET, `Buscar`);

  BuscarTodos = () =>
    this.CreateRequest<PlanoEntidade[]>(ReactService.RequestType.GET, `BuscarTodos`);

  BuscarPorCodigo = (cdPlano: string) =>
    this.CreateRequest<PlanoVinculadoEntidade>(ReactService.RequestType.GET, `BuscarPorCodigo/${cdPlano}`);

  GetSaldado = () =>
    this.CreateRequest<string[]>(ReactService.RequestType.GET, `GetSaldado`);

  ExtratoCodeprev = () =>
    this.CreateRequest<string[]>(ReactService.RequestType.GET, `ExtratoCodeprev`);

  ExtratoSaldado = () =>
    this.CreateRequest<string[]>(ReactService.RequestType.GET, `ExtratoSaldado`);

  GetRelatorioExtratoPorPlanoReferencia = (cdPlano: string, dtInicio: string, dtFim: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GetRelatorioExtratoPorPlanoReferencia/${cdPlano}/${dtInicio}/${dtFim}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

  PossuiDocumentoOpcaoRMV = () =>
    this.CreateRequest<boolean>(ReactService.RequestType.GET, `PossuiDocumentoOpcaoRMV`);

  BaixarDocumentoOpcaoRMV = () =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BaixarDocumentoOpcaoRMV`, null, ReactService.ResponseType.Blob);

}

export const PlanoService = new Plano();
